export default {
    getSettings(state) {
        return state.settings
    },
    getPublicSettings(state) {
        return state.publicSettings
    }
}